module.exports = __webpack_public_path__ + "img/pic1@2x.8938b01f.png";